import * as React from 'react';
import { OverviewLeftSide } from './OverviewLeftSide';
import { OverviewRightSide } from './OverviewRightSide';

import './OverviewLeftSide';
export interface IProfileOverviewProps {
}

export function ProfileOverview(props: IProfileOverviewProps) {


    return (
        <div className="mt-5 md:mt-10 pb-24 profile_overview_main_box">

            <div className="lightBlueBg rounded-md md:rounded-2xl p-2 sm:p-4 xl:p-6 grid grid-cols-6 gap-x-1 sm:gap-x-2 md:gap-x-4 w-full justify-center items-center">
                <div className="text-left">
                    <h2 className="text-xxs xsm:text-xs sm:text-lg md:text-xl xl:text-3xl text-cusBlack dark:text-white font-semibold dark:font-medium">18.6K</h2>
                    <p className="text-l-LightBlack mt-1 dark:text-white text-4xs sm:text-xs lg:text-sm xl:text-base">Items</p>
                </div>
                <div className="text-left">
                    <h2 className="text-xxs xsm:text-xs sm:text-lg md:text-xl xl:text-3xl text-cusBlack dark:text-white font-semibold dark:font-medium">$1.1B</h2>
                    <p className="text-l-LightBlack mt-1 dark:text-white text-4xs sm:text-xs lg:text-sm xl:text-base">Total Volume</p>
                </div>
                <div className="text-left">
                    <h2 className="text-xxs xsm:text-xs sm:text-lg md:text-xl xl:text-3xl text-cusBlack dark:text-white font-semibold dark:font-medium">12.3K</h2>
                    <p className="text-l-LightBlack mt-1 dark:text-white text-4xs sm:text-xs lg:text-sm xl:text-base">Owners</p>
                </div>
                <div className="text-left">
                    <h2 className="text-xxs xsm:text-xs sm:text-lg md:text-xl xl:text-3xl text-cusBlack dark:text-white font-semibold dark:font-medium">$1.4M</h2>
                    <p className="text-l-LightBlack mt-1 dark:text-white text-4xs sm:text-xs lg:text-sm xl:text-base">Highest Sale</p>
                </div>
                <div className="text-left">
                    <h2 className="text-xxs xsm:text-xs sm:text-lg md:text-xl xl:text-3xl text-cusBlack dark:text-white font-semibold dark:font-medium">$79.1K</h2>
                    <p className="text-l-LightBlack mt-1 dark:text-white text-4xs sm:text-xs lg:text-sm xl:text-base">Floor price</p>
                </div>
                <div className="text-left">
                    <h2 className="text-xxs xsm:text-xs sm:text-lg md:text-xl xl:text-3xl text-cusBlack dark:text-white font-semibold dark:font-medium">$1.5B</h2>
                    <p className="text-l-LightBlack mt-1 dark:text-white text-4xs sm:text-xs lg:text-sm xl:text-base">Market Cap</p>
                </div>
            </div>





            <div className="grid grid-cols-1 lg:grid-cols-7 mt-8">
                <div className="col-span-4">
                    <OverviewLeftSide />
                </div>

                <div className="col-span-3">
                    <OverviewRightSide />
                </div>
            </div>














        </div>
    );
}
